module.exports = __webpack_public_path__ + "img/18.f0faa229.png";